module.exports = __webpack_public_path__ + "static/OPERATIONAL_RESEARCH-d8ed1bea3f285d91034434c374379d18.jpeg";